import { render } from "./categoryInfo.vue?vue&type=template&id=b91d4ff6&scoped=true"
import script from "./categoryInfo.vue?vue&type=script&lang=js"
export * from "./categoryInfo.vue?vue&type=script&lang=js"

import "./categoryInfo.vue?vue&type=style&index=0&id=b91d4ff6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b91d4ff6"]])

export default __exports__